import { Logo } from "@/components/Logo";
import { SwooshRibbons } from "@/components/SwooshRibbons";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-[#1C1512]/10 bg-[#F2EDE6] py-16">
    <SwooshRibbons
      idPrefix="footer-tl"
      inView
      className="absolute -left-28 -top-16 h-[320px] w-[480px] opacity-30"
    />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="flex flex-col justify-between gap-12 md:flex-row md:items-start">
        <div>
          <Logo light />
          <p className="mt-6 max-w-xs font-display text-lg italic text-[#5C5248]">
            Sales and commercial growth. Outsourced.
          </p>
        </div>
      </div>
      <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-[#1C1512]/10 pt-8 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8A7F75]">
          © 2026 Ruby Mill. All rights reserved.
        </p>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8A7F75] transition-colors hover:text-ruby"
        >
          Owner Login
        </Link>
      </div>
    </div>
  </footer>
);
